module.exports = __webpack_public_path__ + "static/media/recruitmentProcess-min.9bf0ad1a.jpg";